import 'intersection-observer';
import { PrecisePriceCore } from '@/precise-price/core';
import { Widgets } from '@/precise-price/widgets';
import { PrecisePriceConfig } from '@/entities/config';
import { i18n } from '@/precise-price/i18n';
import { router } from '@/router';
import { makeStore } from '@/store';
import {
	WriteupService,
	StorageService,
	WebsiteService,
	CoreService,
	TradePendingService,
	LeadService,
	ShortUrlService,
	DealProgressService,
	ReserveVehicleService,
	ServiceContainer,
	AmplitudeService,
	AnalyticsService,
} from '@/services';

// TODO: use DI container
const configData = (window.precisePriceV2 as PrecisePriceObject).config;
const config = new PrecisePriceConfig(configData);
const writeupService = new WriteupService(config);
const websiteService = new WebsiteService(config);
const storageService = new StorageService(config);

const services = new ServiceContainer(writeupService,
	websiteService,
	storageService,
	new CoreService(websiteService, storageService, i18n),
	new TradePendingService(config),
	new ShortUrlService(config),
	new LeadService(config),
	new DealProgressService(config),
	new AnalyticsService(),
	new ReserveVehicleService(config),
	new AmplitudeService());

const store = makeStore(services, router);
const precisePriceCore = new PrecisePriceCore(config, store, services, storageService.getClientId());
const widgets = new Widgets(store, services);

precisePriceCore.init();
widgets.init();

import(/* webpackChunkName: "precise-price-app" */ '@/precise-price/precise-price')
	.then(({ PrecisePrice }) => {
		const precisePrice = new PrecisePrice(store, router, services, i18n, new AmplitudeService());

		precisePrice.init();
	});
